var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.banner.id)?_c('div',[_c('customer-context-prompt',{attrs:{"resource":_vm.banner}}),_c('h2',[_vm._v(_vm._s(_vm.$t('edit_banner')))]),_c('banner-form',{attrs:{"banner":_vm.banner}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }